import React from 'react';
import { Link } from 'react-router';
import './SignIn.scss';
const SignIn = ({
  handleUserLogin,
  handleStateChange,
  validator,
  state
}) => {
  return (
    <form className='nf-login-form' onSubmit={(e) => handleUserLogin(e)}>
      <div className='nf-group-input'>
        <input type='email' className='nf-input' value={state.e} id='email' placeholder='Email' name='e' onChange={(e) => handleStateChange('e', e.target.value)} />
        {validator.message('Email Address', state.e, 'required|email')}
      </div>
      <div className='nf-group-input'>
        <input type='password' className='nf-input' value={state.pd} id='password' name='pd' placeholder='Password' onChange={(e) => handleStateChange('pd', e.target.value)} />
        {validator.message('Password', state.pd, 'required|required')} </div>
      <div className='nf-group-input  nf-group-frtpw'>

        <div className="">
          <div className="secstyle-checkbox signin-box login-remember">
            <label>
              <input type='checkbox' checked={state.rm} onChange={(e) => handleStateChange('rm', e.target.value)} /> Remember me
            </label>
          </div>
          <div className='forgetlink-block text-right nf-group-rebforget signin-forget'>
            <Link className="font-italic" to='ForgotPwd'>Forget Password ?</Link>
          </div>
        </div>

      </div>
      <div className='nf-btn-login mt-10'>
        <button className='nf-btn  nf-btn-primary nf-btn-default ' type='submit'>
          Login
        </button>
      </div>
    </form>
  );
};

export default SignIn;


// WEBPACK FOOTER //
// ./src/components/SignIn/SignIn.js